import type { BaseTranslation } from '../i18n-types.js';

const en: BaseTranslation = {};

export default en;
